import React from "react";
import { IconType } from "./types";

const NarvarBadge: IconType = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="#F5F5F5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M15.1974 8.98979C15.1974 11.0216 13.5536 12.6653 11.5218 12.6653H9.40839C9.17357 12.6653 8.98468 12.4765 8.98468 12.2416V8.98979C8.98468 7.7595 7.98412 6.75893 6.75383 6.75893C5.52354 6.75893 4.52297 7.7595 4.52297 8.98979V12.2416C4.52297 12.4765 4.33409 12.6653 4.09926 12.6653H3.50709C3.27226 12.6653 3.08338 12.4765 3.08338 12.2416V8.98979C3.08338 6.95803 4.72717 5.31424 6.75893 5.31424C8.7907 5.31424 10.4345 6.95803 10.4345 8.98979V11.2206H11.5218C12.7521 11.2206 13.7527 10.2201 13.7527 8.98979V5.73795C13.7527 5.50312 13.9416 5.31424 14.1764 5.31424H14.7788C15.0136 5.31424 15.2025 5.50312 15.2025 5.73795C15.2025 5.74816 15.2025 5.75326 15.2025 5.76347L15.1974 8.98979ZM9 0C4.02779 0 0 4.02779 0 9C0 13.9722 4.02779 18 9 18C13.9722 18 18 13.9722 18 9C18 4.02779 13.9722 0 9 0Z"
      fill="inherit"
    />
  </svg>
);

export default NarvarBadge;
